export default __webpack_public_path__ + "static/media/Water_2_M_Normal.592b9bdf.jpg";